import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { Text, GridRow, Heading2, withColor, BiggerText, FullWidthWrapper, PrimaryLinkButton } from './MarketingStyles';

import { Arrow } from '../../images/icons/Icons';

import { inject, observer } from 'mobx-react'

@inject('utilStore')
@observer
class CtaBox extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    const { make_appointment } = this.props.utilStore.util

    let link = this.props.buttonLink
    if(link == "make_appointment_target") link = make_appointment && make_appointment.target

    return (
      <CtaBoxWrapper>
        <GridRow
          desktop="1fr 1fr"
          tablet="1fr" tabletRowGap
          phone="1fr" phoneRowGap
        >
          <FullWidthWrapper>
            <WhiteHeading2>{ this.props.title }</WhiteHeading2>
            <WhiteBiggerText>{ this.props.text }</WhiteBiggerText>
          </FullWidthWrapper>
          <CTAWrapper>
            <CTAButton href={ link } onClick={ this.props.onClick }>{/*<Arrow />*/} { this.props.buttonText }</CTAButton>
          </CTAWrapper>
        </GridRow>
      </CtaBoxWrapper>
    )
  }
}

export default CtaBox

const WhiteHeading2 = withColor(Heading2, 'white')
const WhiteBiggerText = withColor(Text, 'white')

const CtaBoxWrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${ cssVar.colors.blue };
  color: white;
  padding: 50px;

  ${cssVar.breakpoints.tablet} {
    padding: 30px;
  }
`

const CTAWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${cssVar.breakpoints.tablet} {
    width: 100%;
  }
`

const CTAButton = styled(PrimaryLinkButton) `
  font-size: 16px !important;
  line-height: 24px !important;
  width: auto;
  display: inline-block;
  padding: 20px 40px;
  color: ${ cssVar.colors.blue };
  cursor: pointer;

  &:hover {
    color: ${ cssVar.colors.blue };
    text-decoration: none;
  }

  ${cssVar.breakpoints.tablet} {
    width: 100%;
    text-align: center;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/CtaBox.js